<template>
    <div class="publicNumberInfo">

        <div class="header">
            <h1>基本信息</h1>
        </div>

        <table cellspacing="15px">
            <tr class="headimg">
                <td>头像：</td>
                <td class="item-txt">
                    <template v-if="tableData.logourl">
                        <img :src="tableData.logourl" alt="img">
                    </template>
                    <template v-else>
                        <img src="@/common/images/fansmgt/icon_headerimg.png" alt="img">
                    </template>
                </td>
            </tr>
            <tr>
                <td>名称：</td>
                <td class="item-txt">{{tableData.name}}</td>
            </tr>
            <tr>
                <td>公众号类型：</td>
                <td class="item-txt">{{tableData.servicetypeinfo}}</td>
            </tr>
            <tr>
                <td>授权状态：</td>
                <td class="item-txt">{{tableData.verifytypeinfo}}</td>
            </tr>
            <tr>
                <td>公众号原始ID：</td>
                <td class="item-txt">{{tableData.mporgid}}</td>
            </tr>
            <tr>
                <td>TOKEN：</td>
                <td class="item-txt">{{tableData.refreshaccesstoken}}</td>
            </tr>
            <tr>
                <td>过期时间：</td>
                <td class="item-txt">{{tableData.tokenexpiretime}}</td>
            </tr>
        </table>

        <div class="btn">
            <el-button type="primary" @click="add()">重新授权</el-button>
            <el-button type="primary" @click="cleartoken()">刷新TOKEN</el-button>
            <el-button @click="back()">返回上级</el-button>
        </div>


        <el-dialog
            title="公众号授权"
            :visible.sync="dialogVisible"
            width="660" height="220">
            <span>请在公众号中完成公众号授权</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="add()">授权失败，重试</el-button>
                <el-button type="primary" @click="apicontent(),dialogVisible = false">授权成功</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {findMpaccountInfo, getPublicAccount, refreshaccesstoken} from '@/api/accountApi'
    import Loading from 'base/loading/loading'    // 引入 loading 组件
    import {mapGetters, mapActions} from 'vuex'

    export default {
        name: "publicNumberInfo",
        data() {
            return {
                token: JSON.parse(sessionStorage['user']).loginToken, // token
                shopID: JSON.parse(sessionStorage['shop']).ShopID, // 店铺id
                sessionUser: JSON.parse(sessionStorage['user']), // 用户信息
                innerid: this.$route.query.innerid,
                dialogVisible: false,
                tableData: [],  // 表单数据
            }
        },
        mounted() {
            this.apicontent()
        },
        methods: {
            back(){
                this.$router.go(-1)
            },
            cleartoken() {
                // 公众号详情数据
                var data = {
                    // LoginToken: this.token,
                    // ShopID: this.shopID,
                    // ClientType: 3,
                    code: this.tableData.code
                }
                this.setLoading(true)
                refreshaccesstoken ({
                    data: data,
                    success:data => {
                        this.setLoading(false)
                        this.$message.success('TOKEN刷新成功')
                        this.tableData.refreshaccesstoken = data.data.refreshaccesstoken
                        this.tableData.tokenexpiretime = data.data.tokenexpiretime
                        console.log('refreshaccesstoken',data)
                    },
                    error:data => {
                        this.setLoading(false)
                        this.$message.success('TOKEN刷新失败,'+this.data.msg)
                    }
                })
            },
            apicontent() {
                // 公众号详情数据
                var data = {
                    // LoginToken: this.token,
                    // ShopID: this.shopID,
                    // ClientType: 3,
                    innerid: this.innerid
                }
                // console.log(data)

                this.setLoading(true)
                findMpaccountInfo({
                    data: data,
                    success:data => {
                        console.log('findMpaccountInfo',data)
                        this.setLoading(false)
                        this.tableData = data.data
                    },
                    error:data => {
                        this.setLoading(false)
                    }
                })
            },
            add() {
                this.dialogVisible = true
                // 授权
                var data = {
                    // LoginToken: this.token,
                    // ShopID: this.shopID,
                    // ClientType: 3
                }
                this.setLoading(true)
                getPublicAccount({
                    data: data,
                    success:data => {
                        console.log(data)
                        this.setLoading(false)
                        window.open(data.data.authurl)
                    },
                    error: data => {
                        this.setLoading(false)
                    }
                })
            },
            ...mapActions ([
                'setLoading'
            ])
        },
        components: {Loading}
    }
</script>

<style lang="scss" type="text/scss">
    .publicNumberInfo {
        .el-dialog {
            text-align: center;
            .el-dialog__body {
                padding: 0;
                padding-top: 40px;
            }
            .el-button {
                width: 120px;
                margin: 20px 30px;
            }
        }

        .header {
            border-left: solid 2px #409EFF;
            h1 {
                margin-left: 8px;
                color: #303133;
                font-size: 16px;
                font-weight: bold;
            }
        }
        table,
        .btn {
            margin-left: 8px;
        }
        .btn {
            width: 100%;
            padding-top: 30px;
            margin-top: 30px;
            border-top: solid 1px #DCDFE6;
        }
        table {
            .headimg {
                line-height: 60px;
            }
            td {
                float: left;
                display: inline-block;
                margin-top: 20px;
                font-size: 14px;
                color: #303133;

                img {
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                }
            }
            td.item-txt {
                margin-left: 100px;
                width: 650px;
                color: #606266;
                word-break: break-word;
            }
            td:nth-child(1) {
                width: 120px;
            }
        }
    }
</style>
